import type { IterationView } from "@/application/use-cases/b2c/build-b2c-board";
import type { B2cTaskRow } from "@/infrastructure/supabase/b2c-board.types";

// Not `currentIteration`: that also returns an iteration in feedback or already
// merged, which `board.mjs move --iteration` refuses as a target.
export function backlogTargetIteration(iterations: IterationView[]): IterationView | null {
  return (
    iterations.find((i) => i.iteration.status === "marathon") ??
    iterations.find((i) => i.iteration.status === "planned") ??
    null
  );
}

export function planBlockedReason(task: B2cTaskRow, target: IterationView | null): string | null {
  if (task.status === "done") return "Done tasks stay with the iteration that delivered them.";
  if (task.status === "in-review") return "In review — its iteration's merge closes it.";
  if (!target) return "No open iteration — create one first.";
  return null;
}

export function rejectBlockedReason(task: B2cTaskRow): string | null {
  if (task.is_e2e_proof) return "The end-to-end proof cannot be rejected.";
  if (task.status === "done") return "It is already done.";
  return null;
}
